import { useMemo } from "react";
import { ShopifyOrderHeader } from "@/components/view/ShopifyOrderHeader";
import type { ShopifySectionWidgetProps } from "../types";
import { useDetailPageTabs } from "@/contexts/DetailPageTabsContext";

/**
 * Order Header Section Widget
 *
 * Wraps ShopifyOrderHeader to be rendered as a regular section widget.
 * This allows the header to be part of the same container flow as other sections.
 */
export function OrderHeaderSection({
  section,
  formData,
  metaFields,
  meta,
  onFieldChange,
  onSave,
  disabled,
  isSaving,
  isNew,
  documentName,
}: ShopifySectionWidgetProps) {
  // Find customer section from tabs context
  const { tabs: contextTabs } = useDetailPageTabs();

  const customerSection = useMemo(() => {
    // Search through all tabs to find customer-channel or customer section
    for (const tab of contextTabs) {
      const customerSec = tab.sections.find(
        s => s.name === 'customer-channel' || s.name === 'customer'
      );
      if (customerSec) return customerSec;
    }
    return null;
  }, [contextTabs]);

  // Storefront orders show this info in the unified StorefrontOrderBanner
  if (formData.source_channel === "Storefront") return null;

  return (
    <ShopifyOrderHeader
      section={section}
      formData={formData}
      metaFields={metaFields || []}
      meta={meta}
      customerSection={customerSection}
      onFieldChange={onFieldChange}
      onSave={onSave}
      disabled={disabled}
      isSaving={isSaving}
      isNew={isNew}
      documentName={documentName}
    />
  );
}


